/* eslint-disable */
import { useMemo, useState } from 'react';
import { Button } from 'rsuite';
import { Filter } from 'lucide-react';
import { useQualityAnalysisStore } from '../QualityAnalysisStore';
import { useShallow } from 'zustand/react/shallow';
import ParameterSelector from '../ParameterSelector';
import DateRangeSelector from '../DateRangeSelector/DateRangeSelector';
import GroupingDropdown from './Components/GroupingDropdown';

const Filters = () => {
	const {
		qcTypes,
		activeQCType,
		activeTab,
		setActiveQCType,
		activeAnalysisTab,
		configTypes,
		activeConfigType,
		setActiveConfigType,
		timeRangesDropdown,
		activeTimeRangeDropdown,
		setActiveTimeRange,
		productWiseDropdown,
		activeProductWiseDropdown,
		setActiveProductWiseDropdown,
		geographyWiseDropdown,
		activeGeographyWiseDropdown,
		setActiveGeographyWiseDropdown,
	} = useQualityAnalysisStore(
		useShallow((state) => ({
			qcTypes: state.qcTypes,
			activeTab: state.activeTab,
			activeAnalysisTab: state.activeAnalysisTab,
			activeQCType: state.activeQCType,
			setActiveQCType: state.setActiveQCType,
			configTypes: state.configTypes,
			activeConfigType: state.activeConfigType,
			setActiveConfigType: state.setActiveConfigType,
			timeRangesDropdown: state.timeRangesDropdown,
			activeTimeRangeDropdown: state.activeTimeRangeDropdown,
			setActiveTimeRange: state.setActiveTimeRange,
			productWiseDropdown: state.productWiseDropdown,
			activeProductWiseDropdown: state.activeProductWiseDropdown,
			setActiveProductWiseDropdown: state.setActiveProductWiseDropdown,
			geographyWiseDropdown: state.geographyWiseDropdown,
			activeGeographyWiseDropdown: state.activeGeographyWiseDropdown,
			setActiveGeographyWiseDropdown:
				state.setActiveGeographyWiseDropdown,
		}))
	);

	const memoGroupingObj = useMemo(() => {
		if (activeConfigType === 'product') {
			return {
				options: productWiseDropdown,
				activeKey: activeProductWiseDropdown,
				onSelect: setActiveProductWiseDropdown,
			};
		} else if (activeConfigType === 'geography') {
			return {
				options: geographyWiseDropdown,
				activeKey: activeGeographyWiseDropdown,
				onSelect: setActiveGeographyWiseDropdown,
			};
		} else {
			return {
				options: timeRangesDropdown,
				activeKey: activeTimeRangeDropdown,
				onSelect: setActiveTimeRange,
			};
		}
	}, [
		activeConfigType,
		activeProductWiseDropdown,
		activeGeographyWiseDropdown,
		activeTimeRangeDropdown,
		timeRangesDropdown,
		productWiseDropdown,
		geographyWiseDropdown,
		setActiveProductWiseDropdown,
		setActiveGeographyWiseDropdown,
		setActiveTimeRange,
	]);

	return (
		<div className='py-1 px-8'>
			{/* Top row with type selectors and time/date range */}
			<div className='flex justify-between items-end mb-1'>
				{/* Left side selectors */}
				<div className='flex w-2/3 py-1'>
					{/* QC Types or Parameter Selector */}
					<div className='w-1/2 flex flex-col gap-1'>
						{activeAnalysisTab === 'failure' ? (
							<>
								<div className='text-gray-400 font-bold text-xs'>
									Select Failure Parameter
								</div>
								<ParameterSelector />
							</>
						) : (
							activeTab == 'sourcing' && (
								<>
									<div className='text-gray-400 font-bold text-xs'>
										Select QC type
									</div>
									<div className='flex'>
										{qcTypes.map((type, index) => {
											const isFirst = index === 0;
											const isLast =
												index === qcTypes.length - 1;

											return (
												<button
													key={type.key}
													onClick={() =>
														setActiveQCType(
															type.key
														)
													}
													className={`
											py-1.5 px-3 font-medium text-sm
											${
												type.key === activeQCType
													? 'bg-[#E6B800] text-white border-0'
													: 'bg-white text-gray-800  border-gray-300'
											}
											${isFirst ? 'rounded-l-lg' : 'border-l-0'}
											${isLast ? 'rounded-r-lg' : ''}
										`}
												>
													{type.label}
												</button>
											);
										})}
									</div>
								</>
							)
						)}
					</div>
					{/* Configuration Types */}
					<div className='w-1/2 flex flex-col gap-1 ml-4'>
						<div className='text-gray-400 font-bold text-xs'>
							Configuration
						</div>
						<div className='flex'>
							{configTypes.map((type, index) => {
								const isFirst = index === 0;
								const isLast = index === configTypes.length - 1;

								return (
									<button
										key={type.key}
										onClick={() =>
											setActiveConfigType(type.key)
										}
										className={`
											py-1.5 px-3 font-medium text-sm
											${
												type.key === activeConfigType
													? 'bg-[#E6B800] text-white border-0'
													: 'bg-white text-gray-800  border-gray-300'
											}
											${isFirst ? 'rounded-l-lg' : 'border-l-0'}
											${isLast ? 'rounded-r-lg' : ''}
										`}
									>
										{type.label}
									</button>
								);
							})}
						</div>
					</div>
				</div>

				{/* Right side - Selectors and buttons */}
				<div className=' w-1/3 flex items-end justify-end'>
					{/* Test buttons for product/geography selection */}
					{/* Date Range */}

					{/* Time Range */}
					<div className='mr-1 w-2/5'>
						<GroupingDropdown
							options={memoGroupingObj.options}
							activeKey={memoGroupingObj.activeKey}
							onSelect={memoGroupingObj.onSelect}
						/>
					</div>
					<div className='relative mr-1 w-3/5'>
						<DateRangeSelector />
					</div>

					{/* Filters button */}
					{/* <div>
						<Button
							appearance='default'
							className='bg-white text-gray-800 border border-gray-300 font-normal rounded-md h-10 px-4 flex items-center'
						>
							Filters <Filter size={16} className='ml-2' />
						</Button>
					</div> */}
				</div>
			</div>
		</div>
	);
};

export default Filters;
